export const isTypeString = (value: any): value is string => typeof value === 'string';

export const isTypeError = (value: any): value is Error => value instanceof Error;